import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import estimationReducer from './estimation_reducer';
import infoFormReducer from './infoForm_reducer';
import {USER_LOGOUT} from '../actions/types';

const appReducer = combineReducers({
  form,
  estimation: estimationReducer,
  infoForm: infoFormReducer,
});

const rootReducer = (state, action) => {
	/// ALLOW RESET WHEN THE USER IS LOGGING OUT ///
	if (action.type === USER_LOGOUT) {
		Object.keys(state).forEach(key => {
      localStorage.removeItem(`persist:${key}`);
     });
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;
